<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-1">
        <div class="container-fluid">
          <div class="card grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl mb-0 font-bold">Create New Ticket</div>
                <span class="hidden-xs font-bold text-sm text-500 text-md">
                  Having trouble loading information on this page?
                  <Button
                    class="p-button-sm p-button-link p-button-success mx-2 p-0"
                    label="Click here to Reload"
                    @click="reloadPage()"
                  />
                </span>
              </div>
            </div>
            <div class="col-12 md:col-3">
              <div class="">
                <template v-if="$auth.canView('/ebilling/statements')">
                  <Button
                    label="E-Billing - Quick Access"
                    @click="
                      app.openPageDialog({
                        page: 'ebilling/statements',
                        url: `/ebilling/statements`,
                        persistent: true,
                        closeBtn: true,
                        maximized: true,
                        position: 'bottom',
                      })
                    "
                    class="w-full p-button-info p-button-rounded"
                  />
                </template>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-12">
              <div class="">
                <Breadcrumb
                  :home="{
                    icon: 'pi pi-arrow-left text-lg mr-3',
                    label: 'Back',
                    command: () => {
                      $router.go(-1);
                    },
                  }"
                  :model="[
                    {
                      label: 'Create New Ticket',
                      to: '/complaints/add',
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-8 comp-grid">
            <div class="">
              <div class="">
                <div v-if="pageReady">
                  <form
                    ref="observer"
                    tag="form"
                    @submit.prevent="submitForm()"
                    class=""
                  >
                    <div class="surface-100 p-3 text-lg font-bold mb-3">
                      Customer Information
                    </div>
                    <div class="grid card mx-1">
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Primary Telephone *
                        </div>
                        <div id="ctrl-client_id">
                          <InputText
                            ref="ctrlclient_id"
                            :value="formData.client_id"
                            label="Primary Number"
                            type="text"
                            placeholder="Primary Number"
                            class="w-full"
                            pattern="^[0-9]+$"
                            maxlength="12"
                            minlength="10"
                            :disabled="formData.has_client_id"
                            v-tooltip.top.focus="'Eg: 233209013836'"
                            :class="getErrorClass('client_id')"
                            @change="checkIfCustomerExists()"
                            @input="
                              debounce(() => {
                                formData.client_id = $event.target.value;
                              })
                            "
                          >
                          </InputText>
                          <!-- <auto-complete-input-text
                            :class="getErrorClass('client_id')"
                            api-path="components_data/client_id_option_list"
                            ref="ctrlclient_id"
                            v-model="formData.client_id"
                            label="Primary Telephone"
                            pattern="^[0-9]+$"
                            maxlength="12"
                            minlength="12"
                            v-tooltip.top.focus="'Eg: 233209013836'"
                          >
                            <template #option="slotProps">
                              <div class="flex align-items-center">
                                <div>
                                  <div>{{ slotProps.option.label }}</div>
                                  <div
                                    v-if="slotProps.option.caption"
                                    class="text-sm text-500"
                                  >
                                    {{ slotProps.option.caption }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </auto-complete-input-text> -->
                          <small
                            v-if="isFieldValid('client_id')"
                            class="p-error"
                            >{{ getFieldError("client_id") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Secondary Telephone
                        </div>
                        <div id="ctrl-phone_number">
                          <InputText
                            ref="ctrlphone_number"
                            v-model.trim="formData.phone_number"
                            label="Secondary Number"
                            type="text"
                            placeholder="Secondary Number"
                            class="w-full"
                            pattern="^[0-9]+$"
                            maxlength="12"
                            minlength="10"
                            v-tooltip.top.focus="'Eg: 233209013836'"
                            :class="getErrorClass('phone_number')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('phone_number')"
                            class="p-error"
                            >{{ getFieldError("phone_number") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">First Name *</div>
                        <div id="ctrl-first_name">
                          <InputText
                            ref="ctrlfirst_name"
                            v-model.trim="formData.first_name"
                            label="First Name"
                            type="text"
                            placeholder="First Name"
                            class="w-full"
                            pattern="^[A-Za-z-' ]+$"
                            :class="getErrorClass('first_name')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('first_name')"
                            class="p-error"
                            >{{ getFieldError("first_name") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Last Name</div>
                        <div id="ctrl-last_name">
                          <InputText
                            ref="ctrllast_name"
                            v-model.trim="formData.last_name"
                            label="Last Name"
                            type="text"
                            placeholder="Last Name"
                            class="w-full"
                            pattern="^[A-Za-z-' ]+$"
                            :class="getErrorClass('last_name')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('last_name')"
                            class="p-error"
                            >{{ getFieldError("last_name") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Primary Email</div>
                        <div id="ctrl-primary_email">
                          <InputText
                            ref="ctrlprimary_email"
                            v-model.trim="formData.primary_email"
                            label="Primary Email"
                            type="email"
                            maxlength="40"
                            placeholder="Primary Email"
                            class="w-full"
                            :class="getErrorClass('primary_email')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('primary_email')"
                            class="p-error"
                            >{{ getFieldError("primary_email") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Fax Number</div>
                        <div id="ctrl-fax_number">
                          <InputText
                            ref="ctrlfax_number"
                            v-model.trim="formData.fax_number"
                            label="Fax Number"
                            type="text"
                            placeholder="Fax Number"
                            pattern="^[A-Za-z0-9-',_. ]+$"
                            class="w-full"
                            :class="getErrorClass('fax_number')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('fax_number')"
                            class="p-error"
                            >{{ getFieldError("fax_number") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">City</div>
                        <div id="ctrl-city">
                          <InputText
                            ref="ctrlcity"
                            v-model.trim="formData.city"
                            label="City"
                            type="text"
                            placeholder="City"
                            pattern="^[A-Za-z0-9-',_. ]+$"
                            class="w-full"
                            :class="getErrorClass('city')"
                          >
                          </InputText>
                          <small v-if="isFieldValid('city')" class="p-error">{{
                            getFieldError("city")
                          }}</small>
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Address</div>
                        <div id="ctrl-address">
                          <InputText
                            ref="ctrladdress"
                            v-model.trim="formData.address"
                            label="Address"
                            type="text"
                            pattern="^[A-Za-z0-9-',_. ]+$"
                            placeholder="Address"
                            class="w-full"
                            :class="getErrorClass('address')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('address')"
                            class="p-error"
                            >{{ getFieldError("address") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Digital Address
                        </div>
                        <div id="ctrl-digital_address">
                          <InputText
                            ref="ctrldigital_address"
                            v-model.trim="formData.digital_address"
                            label="Digital Address"
                            type="text"
                            pattern="^[a-zA-Z]{2}[0-9-]+$"
                            maxlength="14"
                            placeholder="Digital Address"
                            class="w-full"
                            :class="getErrorClass('digital_address')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('digital_address')"
                            class="p-error"
                            >{{ getFieldError("digital_address") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Account Number</div>
                        <div id="ctrl-account_number-holder">
                          <InputText
                            ref="ctrlaccount_number"
                            v-model.trim="formData.account_number"
                            label="Account Number"
                            type="text"
                            pattern="^[A-Za-z0-9-',_]+$"
                            placeholder="Account Number"
                            class="w-full"
                            :class="getErrorClass('account_number')"
                          >
                          </InputText>
                        </div>
                      </div>
                      <div class="col-12 md:col-12">
                        <div class="mt-3" id="ctrl-customer_id">
                          <api-data-source
                            @loaded="
                              (e) => (formData.customer_id = e[0]?.value)
                            "
                            :load-on-mount="true"
                            :api-path="`components_data/customer_id_option_list?lookup_client_id=${formData.client_id}`"
                          >
                          </api-data-source>
                        </div>
                        <InputText
                          v-model.trim="formData.complaint_id"
                          type="text"
                          hidden
                          :class="getErrorClass('complaint_id')"
                        >
                        </InputText>
                      </div>
                    </div>
                    <div class="surface-100 p-3 text-lg font-bold mb-3">
                      Complaint Information
                    </div>
                    <div class="grid card mx-1">
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Title <em>(optional)</em>
                        </div>
                        <div id="ctrl-title-holder">
                          <InputText
                            ref="ctrltitle"
                            v-model.trim="formData.title"
                            label="Title"
                            type="text"
                            pattern="^[A-Za-z0-9-',_. ]+$"
                            placeholder="Title"
                            class="w-full"
                            :class="getErrorClass('title')"
                          >
                          </InputText>
                          <small v-if="isFieldValid('title')" class="p-error">{{
                            getFieldError("title")
                          }}</small>
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Severity *</div>
                        <div id="ctrl-severity-holder">
                          <Dropdown
                            class="w-full"
                            :class="getErrorClass('severity')"
                            optionLabel="label"
                            optionValue="value"
                            ref="ctrlseverity"
                            v-model="formData.severity"
                            :options="app.menus.complaintsSeverityItems"
                            label="Severity"
                            placeholder="Select ..."
                          >
                          </Dropdown>
                          <small
                            v-if="isFieldValid('severity')"
                            class="p-error"
                            >{{ getFieldError("severity") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Complaint Type *
                        </div>
                        <div id="ctrl-complaint_type-holder">
                          <Dropdown
                            class="w-full"
                            :class="getErrorClass('complaint_type')"
                            optionLabel="label"
                            optionValue="value"
                            ref="ctrlcomplaint_type"
                            v-model="formData.complaint_type"
                            :options="app.menus.complaintTypeItems"
                            label="Complaint Type"
                            placeholder="Select  ..."
                          >
                          </Dropdown>
                          <small
                            v-if="isFieldValid('complaint_type')"
                            class="p-error"
                            >{{ getFieldError("complaint_type") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Site Of Complaint
                        </div>
                        <div id="ctrl-site_of_complaint-holder">
                          <InputText
                            ref="ctrlsite_of_complaint"
                            v-model.trim="formData.site_of_complaint"
                            label="Site Of Complaint"
                            type="text"
                            pattern="^[A-Za-z0-9-',_. ]+$"
                            placeholder="Site Of Complaint"
                            class="w-full"
                            :class="getErrorClass('site_of_complaint')"
                          >
                          </InputText>
                          <small
                            v-if="isFieldValid('site_of_complaint')"
                            class="p-error"
                            >{{ getFieldError("site_of_complaint") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Message or Description *
                        </div>
                        <div id="ctrl-message-holder">
                          <Textarea
                            :class="getErrorClass('message')"
                            class="w-full"
                            ref="ctrlmessage"
                            rows="3"
                            pattern="^[A-Za-z0-9-',_. ]+$"
                            v-model="formData.message"
                            placeholder="Message or Description"
                            type="textarea"
                          >
                          </Textarea>
                          <small
                            v-if="isFieldValid('message')"
                            class="p-error"
                            >{{ getFieldError("message") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Solution</div>
                        <div id="ctrl-solution-holder">
                          <Textarea
                            :class="getErrorClass('solution')"
                            class="w-full"
                            ref="ctrlsolution"
                            rows="3"
                            pattern="^[A-Za-z0-9-',_. ]+$"
                            v-model="formData.solution"
                            placeholder="Solution"
                            type="textarea"
                          >
                          </Textarea>
                          <small
                            v-if="isFieldValid('solution')"
                            class="p-error"
                            >{{ getFieldError("solution") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Source Of Complaint
                        </div>
                        <div id="ctrl-source_of_complaint-holder">
                          <Dropdown
                            class="w-full"
                            :class="getErrorClass('source_of_complaint')"
                            optionLabel="label"
                            optionValue="value"
                            ref="ctrlsource_of_complaint"
                            v-model="formData.source_of_complaint"
                            :options="
                              app.menus.complaintsSourceOfComplaintItems
                            "
                            label="Source Of Complaint"
                            placeholder="Select ..."
                          >
                          </Dropdown>
                          <small
                            v-if="isFieldValid('source_of_complaint')"
                            class="p-error"
                            >{{ getFieldError("source_of_complaint") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-12">
                        <div class="mb-2 font-bold text-sm">
                          Attached Files <em>(optional)</em>
                        </div>
                        <div id="ctrl-attached_files-holder">
                          <div class="mb-3">
                            <Uploader
                              :class="getErrorClass('attached_files')"
                              :auto="true"
                              :fileLimit="5"
                              :maxFileSize="3000000"
                              accept=".jpg,.png,.gif,.jpeg"
                              :multiple="false"
                              style="width: 100%"
                              label="Choose files or drop files here"
                              upload-path="s3uploader/upload/attached_files"
                              v-model="formData.attached_files"
                            ></Uploader>
                          </div>
                          <small
                            v-if="isFieldValid('attached_files')"
                            class="p-error"
                            >{{ getFieldError("attached_files") }}</small
                          >
                        </div>
                      </div>
                    </div>

                    <div class="surface-100 p-3 text-lg font-bold mb-3">
                      Complaint Actions
                    </div>
                    <div class="grid card mx-1">
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Status *</div>
                        <div id="ctrl-status-holder">
                          <Dropdown
                            class="w-full"
                            :class="getErrorClass('status')"
                            optionLabel="label"
                            optionValue="value"
                            ref="ctrlstatus"
                            v-model="formData.status"
                            :options="app.menus.complaintsStatusItems"
                            label="Status"
                            placeholder="Select a value ..."
                          >
                          </Dropdown>
                          <small
                            v-if="isFieldValid('status')"
                            class="p-error"
                            >{{ getFieldError("status") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Action Taken *</div>
                        <div id="ctrl-action_taken-holder">
                          <Dropdown
                            class="w-full"
                            :class="getErrorClass('action_taken')"
                            optionLabel="label"
                            optionValue="value"
                            ref="ctrlaction_taken"
                            v-model="formData.action_taken"
                            :options="app.menus.actionTakenItems"
                            label="Action Taken"
                            placeholder="Select ..."
                          >
                          </Dropdown>
                          <small
                            v-if="isFieldValid('action_taken')"
                            class="p-error"
                            >{{ getFieldError("action_taken") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">Region</div>
                        <div id="ctrl-assigned_region-holder">
                          <Dropdown
                            class="w-full"
                            :class="getErrorClass('assigned_region')"
                            optionLabel="label"
                            optionValue="value"
                            ref="ctrlassigned_region"
                            v-model="formData.assigned_region"
                            :options="app.menus.gwclRegionItems"
                            label="Region"
                            placeholder="Select ..."
                            :filter="true"
                          >
                          </Dropdown>
                          <small
                            v-if="isFieldValid('assigned_region')"
                            class="p-error"
                            >{{ getFieldError("assigned_region") }}</small
                          >
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">District</div>
                        <div id="ctrl-assigned_district-holder">
                          <api-data-source
                            @loaded="formData.assigned_district = ''"
                            :load-on-mount="false"
                            :api-path="`components_data/district_option_list?lookup_region=${formData.assigned_region}`"
                          >
                            <template v-slot="req">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('assigned_district', row)"
                                :loading="req.loading"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrlassigned_district"
                                v-model="formData.assigned_district"
                                :options="req.response"
                                label="District"
                                placeholder="Select ..."
                              >
                              </Dropdown>
                              <small
                                v-if="isFieldValid('assigned_district', row)"
                                class="p-error"
                                >{{
                                  getFieldError("assigned_district", row)
                                }}</small
                              >
                            </template>
                          </api-data-source>
                        </div>
                      </div>
                      <div class="col-12 md:col-6">
                        <div class="mb-2 font-bold text-sm">
                          Officer Handling
                        </div>
                        <div id="ctrl-officer_handling-holder">
                          <InputText
                            ref="ctrlofficer_handling"
                            v-model.trim="formData.officer_handling"
                            label="Officer Handling"
                            type="text"
                            pattern="^[A-Za-z-' ]+$"
                            placeholder="Officer Handling"
                            class="w-full"
                            :class="getErrorClass('officer_handling')"
                          >
                          </InputText>
                        </div>
                      </div>
                      <!-- <div
                        v-if="
                          formData.status ==
                          'assigned to district'
                        "
                        class="col-12 md:col-6"
                      >
                        <div class="mb-2 font-bold text-sm">Officer Handling</div>
                        <div id="ctrl-assigned_to-holder">
                          <api-data-source
                            @loaded="formData.officer_handling = ''"
                            :load-on-mount="false"
                            :api-path="`components_data/district_offices_users_option_list?lookup_district=${formData.assigned_district}`"
                          >
                            <template v-slot="req">
                              <Dropdown
                                class="w-full"
                                :class="getErrorClass('assigned_to', row)"
                                :loading="req.loading"
                                optionLabel="label"
                                optionValue="value"
                                ref="ctrlassigned_to"
                                v-model="formData.assigned_to"
                                :options="req.response"
                                label="Assigned To"
                                placeholder="Select ..."
                              >
                              </Dropdown>
                              <small
                                v-if="isFieldValid('assigned_to', row)"
                                class="p-error"
                                >{{ getFieldError("assigned_to", row) }}</small
                              >
                            </template>
                          </api-data-source>
                        </div>
                      </div> -->
                    </div>

                    <div v-if="showSubmitButton" class="text-center my-3">
                      <Button
                        class="p-button-primary p-button-rounded"
                        type="submit"
                        label="Submit"
                        icon="pi pi-send"
                        :loading="saving"
                      />
                    </div>
                  </form>
                </div>
                <template v-else>
                  <div>
                    <table class="p-datatable-table w-full">
                      <tbody>
                        <tr v-for="n in 3" :key="n">
                          <td class="text-left" style="width: 100%">
                            <Skeleton height="10rem" class="m-2" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 comp-grid">
            <div class="">
              <div v-if="formData.client_id">
                <ComplaintsSublistPage
                  ref="complaintsListPage"
                  :limit="3"
                  field-name="complaints.client_id"
                  :field-value="formData.client_id"
                  :refresh-token="formData.token"
                  :show-header="true"
                  :show-breadcrumbs="true"
                  :show-footer="true"
                  :paginate="true"
                  v-if="pageReady"
                >
                </ComplaintsSublistPage>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, watch, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, email, numeric } from "@/services/validators";
import { utils } from "@/utils";
import { useRoute, useRouter } from "vue-router";
import { useApp } from "@/composables/app.js";
import { useStore } from "vuex";
import { useEditPage } from "@/composables/complaintspage.js";
import ComplaintsSublistPage from "../complaints/sublist.vue";

const props = defineProps({
  id: [String, Number],
  action: [String],
  pageName: {
    type: String,
    default: "complaints",
  },
  routeName: {
    type: String,
    default: "complaintsadd",
  },
  apiPath: {
    type: String,
    default: "complaints/add",
  },
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterSave: {
    type: String,
    default: "Record added successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  pageData: {
    // use to set formData default values from another page
    type: Object,
    default: () => {},
  },
});
const app = useApp();
const route = useRoute();
const store = useStore();
const router = useRouter();

let onActiveCall = computed(() => store.state.app.onActiveCall);
let onTicketSubmitted = computed(() => store.state.app.onTicketSubmitted);

const formDefaultValues = {
  token: "",
  client_id: "",
  has_client_id: false,
  customer_id: "",
  title: "",
  severity: "",
  complaint_type: "",
  site_of_complaint: "",
  message: "",
  solution: "",
  source_of_complaint: "",
  status: "",
  action_taken: "",
  assigned_region: "",
  assigned_district: "",
  officer_handling: "",
  assigned_to: "",
  attached_files: "",
  phone_number: "",
  first_name: "",
  last_name: "",
  primary_email: "",
  fax_number: "",
  city: "",
  address: "",
  digital_address: "",
  account_number: "",
  complaint_id: "",
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    client_id: { numeric, required },
    customer_id: { numeric },
    complaint_id: {},
    title: {},
    severity: { required },
    complaint_type: { required },
    site_of_complaint: {},
    message: { required },
    solution: {},
    source_of_complaint: {},
    status: { required },
    action_taken: { required },
    assigned_region: {},
    assigned_district: {},
    officer_handling: {},
    assigned_to: { numeric },
    attached_files: {},
    account_number: {},
    phone_number: {},
    first_name: { required },
    last_name: {},
    primary_email: { email },
    fax_number: {},
    city: {},
    address: {},
    digital_address: {},
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useEditPage(props, formData, v$, afterSubmit, beforeSubmit);
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  // if (formData.complaint_id && onActiveCall.value) {
  //   app.flashMsg(
  //     "Call in Session",
  //     "Kindly HangUp call before submitting ticket",
  //     "warn",
  //     8000
  //   );
  //   return false;
  // }
  return true;
}
// after form submited to api
// reset form data.
// redirect to another page
function afterSubmit(response) {
  store.commit("app/setOnTicketSubmitted", 2);
  store.commit("app/setSipSessionTrackerCode", utils.uuid());

  app.flashMsg(props.msgAfterSave);
  if (props.redirect) app.navigateTo(`/complaints`);
  // location.reload();
}
//page state
const {
  submitted, // form submitted state - Boolean
  saving, // form api submiting state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page methods
const {
  load,
  debounce,
  submitForm, //submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;

function checkIfCustomerExists() {
  let telephone = formData.client_id.toString().replace(/^0+/, "");
  if (telephone.toString().length < 10) {
    telephone = "233" + telephone;
  }
  if (telephone.toString().length > 11) {
    app.navigateTo(`/complaints/add/${telephone}`);
  }
}

function reloadPage() {
  load();
}

watch(route, () => {
  // console.log("_______ watch called________ ");
  Object.assign(formData, {
    token: utils.uuid(),
    client_id: route.params.id || null,
    has_client_id: route.params.id ? true : false,
  });
  if (onTicketSubmitted.value == 1) {
    load();
  }
});

onMounted(() => {
  const pageTitle = "Create New Ticket";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
  store.commit("app/setOnTicketSubmitted", 1);
  Object.assign(formData, {
    source_of_complaint: "Call Center",
    status: "opened",
    client_id: route.params.id || null,
    has_client_id: route.params.id ? true : false,
  });
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
<style scoped></style>
